import { render, staticRenderFns } from "./hot-sale-search-results.vue?vue&type=template&id=23ae3b14&scoped=true&v-if=storeHotSale"
import script from "./hot-sale-search-results.vue?vue&type=script&lang=js"
export * from "./hot-sale-search-results.vue?vue&type=script&lang=js"
import style0 from "./hot-sale-search-results.vue?vue&type=style&index=0&id=23ae3b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae3b14",
  null
  
)

/* custom blocks */
import block0 from "./hot-sale-search-results.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports